module.exports = __webpack_public_path__ + "static/img/assembler_256.3e40657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assembler_256.png
// module id = 4+OT
// module chunks = 0